var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLineEditPen = function SvgIconLineEditPen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.276 4.667 11 1.39l-9 9v3.276h3.276zM11 3.277 10.276 4l1.39 1.39.724-.723zM9.333 4.942l-6 6v1.39h1.39l6-6z",
    clipRule: "evenodd"
  })));
};
export { SvgIconLineEditPen as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNC4yNzYxIDQuNjY2NzZMMTEgMS4zOTA2MkwyIDEwLjM5MDZWMTMuNjY2OEg1LjI3NjE0TDE0LjI3NjEgNC42NjY3NlpNMTEuMDAwMSAzLjI3NjQ1TDEwLjI3NjEgMy45OTk5N0wxMS42NjY0IDUuMzkwMzFMMTIuMzkwNCA0LjY2Njc5TDExLjAwMDEgMy4yNzY0NVpNOS4zMzMzMyA0Ljk0Mjk1TDMuMzMzMzMgMTAuOTQyOFYxMi4zMzM0SDQuNzIzMzNMMTAuNzIzNyA2LjMzMzI5TDkuMzMzMzMgNC45NDI5NVoiIC8+Cjwvc3ZnPgo=";